// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3VXNc","unreadBadge":"styles_unreadBadge__1Fn01","modalContent":"styles_modalContent__1zc1_","modal":"styles_modal__3mFO8"};